import React from 'react';

import Page from '@/components/Page/Page';
import ContractHeadersContainer from './AddContract.container';

export default function AddContract(): JSX.Element {
  return (
    <Page
      pageTitle="Add Contract"
      padding={true}
    >
      <ContractHeadersContainer />
    </Page>
  );
}
